/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Link, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { getCardBgColors, refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import { Styles } from '../../constants';

/* Services */

/**
 * Renders the Card Program 2 Column Group Component.
 *
 * @param programs.programs
 * @param {object} programs - Content from api.
 * @param {string} region - Current User Country.
 * @param {string} lang - Current User Language.
 * @param {string} cardType - Type of Card
 * @param programs.region
 * @param programs.lang
 * @param programs.cardType
 * @returns {ReactElement} CardProgram2ColumnGroup card component.
 */
const CardProgram2ColumnGroup = ({ programs, region, lang, cardType }) => {
  let bgColors = getCardBgColors(cardType);
  const clips = Styles.clipPaths;
  return (
    <Box
      display={'grid'}
      placeItems={'center'}
      textAlign="center"
      justifyContent="center"
    >
      <Box
        display="flex"
        justifyContent="center"
        gridGap="30px"
        flexWrap="wrap"
        maxWidth="1170px"
        flexDirection="row"
        mt="15px"
        mb="30px"
      >
        {/* dynamic binding */}
        {programs &&
          programs.length > 0 &&
          programs.map((item, index) => {
            return (
              <Box //this is the main container
                textAlign="left"
                // w={{ base: '100%', md: '40%' }}
                w={{ base: '302px', sm: '330px', lg: '370px', xl: '470px' }}
                // margin={{
                //   base: '0 0 30px 0',
                //   md: '0 20px 50px 0',
                //   lg: index === 2 ? '0' : '0 30px 15px 0',
                // }}
                // padding="0 0 20px 0"

                boxShadow="0 12px 15px -6px rgb(0 0 0 / 30%)"
                // minHeight={{ base: 'unset', lg: '475px' }}
                background="#ffffff"
                key={nanoid()}
                _hover={{ boxShadow: '0 0 48px 0 rgb(0 0 0 / 25%)' }}
              >
                {!item?.buttonText && (
                  <NextLink
                    href={refineUrlDomain(item?.cardLink, region, lang)}
                    passHref
                    prefetch={false}
                    legacyBehavior>
                    <Link
                      _hover={{
                        textDecoration: 'none',
                      }}
                      cursor={item?.cardLink ? 'cursor' : 'auto'}
                    >
                      <Box
                        background={bgColors[index % bgColors.length]}
                        position={'relative'}
                      >
                        <Box h={'50%'}>
                          {' '}
                          <LazyLoadImageComponent
                            src={item?.thumbnail?.url}
                            alt={item?.thumbnail?.title}
                            title={item?.thumbnail?.title}
                            // clipPath="polygon(0 0, 100% 0, 100% 100%, 0% 92%)"
                            clipPath={clips[index % clips.length]}
                            h={{ xl: '330px', sm: '220px' }}
                            w="100%"
                            objectFit="cover"
                            bgColor="#EEEEEE"
                          />
                        </Box>
                        <Text
                          fontFamily="FedraSansStd-A-medium"
                          fontSize={{
                            base: '24px',
                            md: '17px',
                            lg: '24px',
                          }}
                          padding="18px"
                          color="#ffffff"
                          h="20%"
                        >
                          {item.title}
                        </Text>
                      </Box>
                      <Box>
                        <Text
                          fontSize={{ base: '17px', md: '13px', lg: '17px' }}
                          padding="18px"
                          lineHeight="1.6"
                          fontFamily="FedraSansStd-book"
                          color="#28231e"
                        >
                          <StructuredTextParser
                            str={render(item.description)}
                            region={region}
                            lang={lang}
                            mt="0"
                            className="truncate-text"
                          />
                        </Text>
                        {item?.secondCtaLabel && (
                          <Box>
                            <NextLink
                              href={refineUrlDomain(
                                item?.secondCtaLink,
                                region,
                                lang
                              )}
                              passHref
                              legacyBehavior>
                              <Link
                                mb="20px"
                                display="block"
                                fontWeight={500}
                                fontFamily="FedraSansStd-book"
                                fontSize={'18px'}
                                h={'auto'}
                                textAlign="center"
                                padding="10px 36px"
                                borderRadius="3px"
                                color="#cf4520"
                                textDecoration="underline"
                                _hover={{
                                  textDecoration: 'none',
                                }}
                                target={
                                  item?.secondCtaLink.indexOf('http') > -1 &&
                                    item?.secondCtaLink.indexOf(config.cdnPath) <
                                    0
                                    ? '_blank'
                                    : ''
                                }
                              >
                                {item?.secondCtaLabel}
                              </Link>
                            </NextLink>
                          </Box>
                        )}
                        {/* {item?.buttonText && (
                          <Box>
                            <NextLink
                              href={refineUrlDomain(
                                item?.buttonLink,
                                region,
                                lang
                              )}
                              passHref
                            >
                              <Link
                                width="190px"
                                display="block"
                                fontWeight={500}
                                fontFamily="FedraSansStd-book"
                                fontSize={'18px'}
                                bgColor="#cf4520"
                                h={'auto'}
                                textAlign="center"
                                padding="10px 36px"
                                borderRadius="3px"
                                color="#faf7f0"
                                textDecoration="none"
                                _hover={{
                                  bg: '#000054',
                                }}
                                margin="20px auto"
                                target={
                                  item?.buttonLink.indexOf('http') > -1 &&
                                    item?.buttonLink.indexOf(config.cdnPath) < 0
                                    ? '_blank'
                                    : ''
                                }
                              >
                                {item?.buttonText}
                              </Link>
                            </NextLink>
                          </Box>
                        )} */}
                      </Box>
                    </Link>
                  </NextLink>
                )}

                {item?.buttonText && (
                  <Box>
                    <Box
                      background={bgColors[index % bgColors.length]}
                      position={'relative'}
                    >
                      <Box h={'50%'}>
                        <LazyLoadImageComponent
                          src={item?.thumbnail?.url}
                          alt={item?.thumbnail?.title}
                          title={item?.thumbnail?.title}
                          // clipPath="polygon(0 0, 100% 0, 100% 100%, 0% 92%)"
                          clipPath={clips[index % clips.length]}
                          h={{ xl: '330px', sm: '220px' }}
                          w="100%"
                          objectFit="cover"
                          bgColor="#EEEEEE"
                        />
                      </Box>
                      <Text
                        fontFamily="FedraSansStd-A-medium"
                        fontSize={{
                          base: '24px',
                          md: '17px',
                          lg: '24px',
                        }}
                        padding="18px"
                        color="#ffffff"
                        h="20%"
                      >
                        {item.title}
                      </Text>
                    </Box>
                    <Box>
                      <Text
                        fontSize={{ base: '17px', md: '13px', lg: '17px' }}
                        padding="18px"
                        lineHeight="1.6"
                        fontFamily="FedraSansStd-book"
                        color="#28231e"
                      >
                        <StructuredTextParser
                          str={render(item.description)}
                          region={region}
                          lang={lang}
                          mt="0"
                          className="truncate-text"
                        />
                      </Text>
                      {item?.secondCtaLabel && (
                        <Box>
                          <NextLink
                            href={refineUrlDomain(
                              item?.secondCtaLink,
                              region,
                              lang
                            )}
                            passHref
                            legacyBehavior>
                            <Link
                              mb="20px"
                              display="block"
                              fontWeight={500}
                              fontFamily="FedraSansStd-book"
                              fontSize={'18px'}
                              h={'auto'}
                              textAlign="center"
                              padding="10px 36px"
                              borderRadius="3px"
                              color="#cf4520"
                              textDecoration="underline"
                              _hover={{
                                textDecoration: 'none',
                              }}
                              target={
                                item?.secondCtaLink.indexOf('http') > -1 &&
                                  item?.secondCtaLink.indexOf(config.cdnPath) < 0
                                  ? '_blank'
                                  : ''
                              }
                            >
                              {item?.secondCtaLabel}
                            </Link>
                          </NextLink>
                        </Box>
                      )}
                      {item?.buttonText && (
                        <Box>
                          <NextLink
                            href={refineUrlDomain(
                              item?.buttonLink,
                              region,
                              lang
                            )}
                            passHref
                            legacyBehavior>
                            <Link
                              width="190px"
                              display="block"
                              fontWeight={500}
                              fontFamily="FedraSansStd-book"
                              fontSize={'18px'}
                              bgColor="#cf4520"
                              h={'auto'}
                              textAlign="center"
                              padding="10px 36px"
                              borderRadius="3px"
                              color="#faf7f0"
                              textDecoration="none"
                              _hover={{
                                bg: '#000054',
                              }}
                              margin="20px auto"
                              target={
                                item?.buttonLink.indexOf('http') > -1 &&
                                  item?.buttonLink.indexOf(config.cdnPath) < 0
                                  ? '_blank'
                                  : ''
                              }
                            >
                              {item?.buttonText}
                            </Link>
                          </NextLink>
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </Box>
            );
          })}
      </Box>
    </Box>
  );
};

export default CardProgram2ColumnGroup;
